/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { useHttp } from '../../hooks/httpHook';
import { stack } from '../../redux/actions/filterActions';
import { experiences } from '../../redux/actions/clsActions';
import { connect, useSelector } from 'react-redux';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles } from '@material-ui/core/styles';

import { isMobile } from "react-device-detect";

const useStyles = makeStyles((theme) => ({
  
  icon: {
    paddingLeft: 10,
    paddingTop: 13,
  },
  chip: {
    maxWidth: 250,
    color: '#3C70F1',
  },
  label: {
    color: '#16294680',
    fontSize: 16,
    fontWeight: 400,
    marginTop: 10,
  },
  selectBorder: {
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#0000ff00',
    },
    '&$disabled': {
      borderColor: '#0000ff00',
    },
  },
  paper: {
    minWidth: isMobile ? 335 : 309,
    maxWidth: isMobile ? 335 : 309,
    marginTop: -10,
    border: '1px  solid #E3EFFE',
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
},
}
));

const DelIcon = (props) => {
  const classes = useStyles();


  return (

    <SvgIcon className={classes.icon}>
      <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.930781 11.0722L1.10663 10.8945L0.930781 11.0722C1.17037 11.3093 1.55774 11.3093 1.79733 11.0722L6.05263 6.86121L10.3079 11.0722C10.5475 11.3093 10.9349 11.3093 11.1745 11.0722C11.4155 10.8337 11.4155 10.4458 11.1745 10.2073L6.92291 6L11.1745 1.79271C11.4155 1.55418 11.4155 1.16635 11.1745 0.92782L10.9991 1.10509L11.1745 0.927819C10.9349 0.690727 10.5475 0.690727 10.3079 0.927819L10.4828 1.10453L10.3079 0.927819L6.05263 5.13879L1.79733 0.927819C1.55775 0.690727 1.17037 0.690727 0.930781 0.927819C0.68974 1.16635 0.68974 1.55418 0.930781 1.79271L5.18236 6L0.930781 10.2073L1.10663 10.385L0.930781 10.2073C0.68974 10.4458 0.68974 10.8336 0.930781 11.0722Z" fill="#3C70F1" stroke="#3C70F1" strokeWidth="0.5" strokeLinecap="round" />
      </svg>
    </SvgIcon>
  )
}

const Stack = ({ stack, experiences }) => {

  const { request, } = useHttp();
  const [classifier, setClassifier] = useState([]);
  const [state, setState] = useState([]);
  const classes = useStyles();
  const [disableInput, setDisableInput] = useState(false);

  useEffect(() => {
    const getClassifier = async () => {
      let cls;
      let result = await request(`/experiences `, 'get')
      if (result && !result.error && result.data.length) {
        experiences(result.data);
        cls = result.data.reverse().filter((obj, pos, arr) => {

          return arr
            .map(mapObj => mapObj.name)
            .indexOf(obj.name) === pos;
        }).reverse();
        setClassifier(cls);
        if (localStorage.getItem('stack')) {
          let ids = localStorage.getItem('stack').split(',');
          let val = [];
          for (let i = 0; i < ids.length; i++) {
            val.push(cls.find((item) => item.id.toString() === ids[i]));
          }
          setState(val);
          stack(val);
          setDisableInput(val.length >= 3);
        }
      }


    };
    getClassifier();
  }, [request, experiences, stack]);

  const filterReducer = useSelector((state) => state.filterReducer);

  useEffect(() => {
    if (!filterReducer.stack) {
      setState([]);
    }
  }, [filterReducer.stack]);


  const handleChange = (val) => {
    let ids = []
    setState(val);
    stack(val);
    ids = val.map(item => item.id);
    localStorage.setItem('stack', ids.join());
    setDisableInput(val.length >= 3);
  }


  const deleteExperience = (val) => {
    if (val) {
      let ids = []
      let cuttentState = state;
      cuttentState = cuttentState.filter(item => {
        return item.id !== val
      });

      setState(cuttentState);
      stack(cuttentState);
      ids = cuttentState.map(item => item.id);
      localStorage.setItem('stack', ids.join());
      setDisableInput(val.length >= 3);
    }
  }

  const handleDelete = (val) => {
    return true;
  };

  return (
    <div >
      <Autocomplete
        className={classes.selectBorder}
        classes={{ paper: classes.paper }}
        multiple
        id="tags-outlined"
        disabled={disableInput}
        options={classifier}
        getOptionLabel={(option) => option.name}
        onChange={(event, newValue) => { handleChange(newValue) }}
        value={state}
        filterSelectedOptions
        disableClearable
        forcePopupIcon={false}
        overflow="hidden"
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              className={classes.chip}
              onClick={() => deleteExperience(option.id)}
              deleteIcon={<DelIcon value={option} />}
              onDelete={handleDelete}
              overflow="hidden"
              key={option.id}
              label={option.name}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            overflow="hidden"
            label="Стек (максимум 3 технологии)"
            InputLabelProps={{
              shrink: true,
              classes: { root: classes.label }
            }}
          />
        )}
      />


    </div>
  );
}

const mapStateToProps = state => ({
  stack: state.stack,
  experiences: state.experiences,
})

export default connect(mapStateToProps, { stack, experiences })(Stack)
